import { useMutation } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { CASE_DETAIL } from "../types/CommonTypes";
import { UPDATE_CASE_REQUEST } from "../types/RequestTypes";
import { AxiosResponse } from "axios";
import { updateCaseDetailInCache } from "./useGetCaseDetailQuery";

export async function updateCase({
  data,
  hospitalId,
  tenantId,
}: UPDATE_CASE_REQUEST): Promise<AxiosResponse<CASE_DETAIL>> {
  const { id, ...restData } = data;
  return fetcher({
    url: `case/${id}`,
    method: "PATCH",
    data: restData,
    headers: {
      "x-hospital-id": hospitalId,
      "x-tenant-id": tenantId,
    },
  });
}

export default function useUpdateCaseMutation() {
  return useMutation({
    mutationFn: updateCase,
    onSuccess: (_, { data, hospitalId }) => {
      const { id, ...restData } = data;
      updateCaseDetailInCache({
        caseId: id,
        hospitalId,
        data: restData,
      });
    },
  });
}
